import { Tooltip } from "flowbite-react";
import { AnimatedNumber as AnimatedNumberShared } from "../../components/common/Animated";
import { StrategyEntityItemType } from "../../services/strategyMap";
import { getWorkItemBreakdownTooltipContent } from "../../pages/Projects/sections/Project/sections/WorkItemBreakdownTooltip";

export function EntityToolTip(props: { data: StrategyEntityItemType }) {
    const data = props.data || [];
    const entities = data.entities;
    const totalCount = entities.length;

    // Determine the child entity type name (singular)
    // Assuming homogeneus list or picking majority/first.
    // StrategyEntityItemType has 'type' and 'entity_type'. 'type' is often specific (e.g. 'epic', 'project').
  
    const tooltipContent = getWorkItemBreakdownTooltipContent(data.child_entity_types, `Total Work Items`);
    return (
      <Tooltip placement="top" content={tooltipContent}>
        <AnimatedNumberShared
          value={totalCount}
          className="flex items-center font-medium text-xl text-light-text-primary dark:text-white"
          formatter={(n) => n.toString().padStart(2, "0")}
        />
      </Tooltip>
    );
}